<template>
  <qx-card-form title="证件信息" v-show="!userInfo" :defaultContentShow="false">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="140px">
      <section class="titleLine" slot="idcard">
        <span>身份证信息</span>
        <span>
          <CtrlDisplayTitle
            :ctrlForm="baseForm"
            :childItemList="[
          'idenPictureFront',
          'idenPictureBack',
          'identification']"
          />
        </span>
      </section>
      <section class="titleLine" slot="driverCard">
        <span>驾驶证信息</span>
        <span>
          <CtrlDisplayTitle
            :ctrlForm="baseForm"
            :childItemList="[
          'adriverLicenseOriginal',
          'adriverLicenseDuplicate',
          'vehicleType',
          'driverLicenseTime']"
          />
        </span>
      </section>
      <section class="titleLine" slot="workCard">
        <span>从业资格证</span>
        <span>
          <CtrlDisplayTitle
            :ctrlForm="baseForm"
            :childItemList="[
          'qcCerti',
          'qcCertiType',
          'qcCertiTime']"
          />
        </span>
      </section>
      <section class="titleLine" slot="otherCard">
        <span>合同/协议</span>
        <span>
          <CtrlDisplayTitle
            :ctrlForm="baseForm"
            :childItemList="[
          'safetyAgreement',
          'driverContract']"
          />
        </span>
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  getFileUrl,
  getIdCardInfo,
  getDrivingLicense,
} from 'api';
import { getBigImg } from '@qx/utils/index';
import CtrlDisplayTitle from 'components/ctrlDisplayTitle';
export default {
  components: {
    CtrlDisplayTitle,
  },
  methods: {
    receiveData (tar, val) {
      this.userInfo = val.userInfo;
      if (this.userInfo && this.userInfo.identification) {
        this.$refs.baseForm.setVal('identification', this.userInfo.identification);
      }
    },
    getBaseFormInfo (targetForm) {
      this.receiveBaseForm = targetForm;
    },
    setList (enums) {
      this.baseForm.qcCertiTypeOptions = enums[0];
      this.baseForm.vehicleTypeOptions = enums[1];
    },
    async dealImg ({ form, names, type }) {
      for (let i = 0; i < names.length; i++) {
        const name = names[i];
        if (type === 'set') { // init初始化
          let result = [];
          const fileId = form[name];
          const fileUrl = form[name + 'Url'] || form[name + 'FullUrl'];
          if (fileId && fileUrl && (fileUrl.indexOf('http') === 0 || fileUrl.indexOf('/local-uploads/') === 0)) { // 地址已经可直接展示
            result = [{
              id: fileId,
              url: fileUrl,
            }];
          } else if (fileId && fileUrl && fileUrl.indexOf('blob:') === 0) { // 浏览器临时预览地址不能作为回显地址，按附件ID重查
            result = await this.getAttachFileList(fileId, fileUrl);
          } else if (fileId && fileUrl && fileUrl.indexOf('http') === -1) { // 地址没带http，请求接口获取
            result = await this.getAttachFileList(fileId, fileUrl);
          } else if (fileId) {
            result = await this.getAttachFileList(fileId, fileUrl);
          } else if (fileUrl && fileUrl.indexOf('blob:') !== 0) {
            result = [{
              id: fileId,
              url: fileUrl,
            }];
          }
          form[name] = result;
        } else { // 获取值
          const list = Array.isArray(form[name]) ? form[name] : [];
          const val = list[0] || {};
          if (val.id) {
            form[name] = val.id;
            form[name + 'Url'] = this.getAttachDisplayUrl(val);
          } else if (val.url) {
            form[name] = '';
            form[name + 'Url'] = val.url;
          } else {
            form[name] = '';
            form[name + 'Url'] = '';
          }
        }
      }
    },
    async getAttachFileList (flowId, fallbackUrl) {
      try {
        const urlRes = await getFileUrl({
          flowIds: flowId,
          _GRID_TYPE: 'jq',
        });
        const rows = urlRes && Array.isArray(urlRes.rows) ? urlRes.rows : [];
        const info = rows[0] || (urlRes && this.getAttachDisplayUrl(urlRes) ? urlRes : null);
        const url = this.getAttachDisplayUrl(info) || fallbackUrl;
        if (url && url.indexOf('blob:') !== 0) {
          return [{
            id: flowId,
            url,
          }];
        }
      } catch (e) {
        console.error('[driver imgInfo] query attach url failed:', flowId, e);
      }
      return fallbackUrl && fallbackUrl.indexOf('blob:') !== 0 ? [{
        id: flowId,
        url: fallbackUrl,
      }] : [];
    },
    getAttachDisplayUrl (info) {
      if (!info) {
        return '';
      }
      return info.fullPathUrl || info.fullPath || info.url || info.picFullUrl || info.storePath || info.picUrl || '';
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // 图片处理
        await this.dealImg({
          form: formData,
          names: [
            'userPrice', 'idenPictureFront', 'idenPictureBack', 'adriverLicenseOriginal',
            'adriverLicenseDuplicate', 'qcCerti', 'lugeAgreement', 'safetyAgreement',
            'driverContract',
          ],
        });
        // 驾驶证证件有效期
        const driverLicenseTime = formData.driverLicenseTime || [];
        formData.driverLicenseTime = this.formatDate(driverLicenseTime[0]);
        formData.driverLicenseExpiredTime = driverLicenseTime[1] === '长期' || driverLicenseTime[1] === '' ? this.formatDate(new Date('9999-12-31')) : this.formatDate(driverLicenseTime[1]);
        // 从业证证件有效期
        const qcCertiTime = formData.qcCertiTime || [];
        formData.qcCertiTime = this.formatDate(qcCertiTime[0]);
        formData.qcCertiExpiredTime = this.formatDate(qcCertiTime[1]);
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },

    async sub () {
      if (this.userInfo) {
        return {};
      } else {
        const res = await this.handleSubData();
        return res;
      }
    },
    async init (data = {}) {
      this.$refs.baseForm.reset();
      await this.dealImg({
        form: data,
        names: [
          'userPrice', 'idenPictureFront', 'idenPictureBack', 'adriverLicenseOriginal',
          'adriverLicenseDuplicate', 'qcCerti', 'lugeAgreement', 'safetyAgreement',
          'driverContract',
        ],
        type: 'set',
      });
      if (data.vehicleType !== undefined && data.vehicleType !== null && data.vehicleType !== -1) { // 准驾车型
        data.vehicleType = String(data.vehicleType);
      } else {
        data.vehicleType = '';
      }
      if (data.qcCertiType !== undefined && data.qcCertiType !== null && data.qcCertiType !== -1) { // 从业证类型
        data.qcCertiType = String(data.qcCertiType);
      } else {
        data.qcCertiType = '';
      }
      if (data.driverLicenseTime) { // 驾驶证证件有效期
        if (data.driverLicenseExpiredTime && data.driverLicenseExpiredTime.includes('9999-12-31')) {
          data.driverLicenseExpiredTime = '长期';
        }
        data.driverLicenseTime = [
          new Date(data.driverLicenseTime),
          data.driverLicenseExpiredTime === null || data.driverLicenseExpiredTime === '长期' ? '' : new Date(data.driverLicenseExpiredTime),
        ];
      }
      if (data.qcCertiTime) { // 从业证证件有效期
        data.qcCertiTime = [
          new Date(data.qcCertiTime),
          new Date(data.qcCertiExpiredTime),
        ];
      }
      this.$refs.baseForm.setVal(data);
    },
  },
  data () {
    return {

      userInfo: null,
      receiveBaseForm: {},
      otherFormData: {
      },
      isLongTerm: '',
      value1: '',
      value2: '',
      baseForm: {
        vehicleTypeOptions: [], // 准驾车型
        qcCertiTypeOptions: [], // 从业证类型
        inline: true,
        form: [
          {
            value: 'idcard',
            allCustom: true,
          },
          {
            label: '身份证头像面',
            value: 'idenPictureFront',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            attr: {
              limit: 1,
            },
            default: [],
            onChange: async (arr) => {
              if (arr && arr[0] && arr[0].url) {
                const loading = this.$loading({
                  background: 'rgba(0, 0, 0, 0.7)',
                });
                const idcardInfo = await getIdCardInfo({ url: getBigImg(arr[0].url) });
                loading.close();
                let msg = '您上传的身份证照片，系统识别出';
                const name = idcardInfo.name;
                const identification = idcardInfo.identification;
                if (name) {
                  msg += `姓名为：${name}，`;
                  if (this.receiveBaseForm && this.receiveBaseForm.setVal) {
                    this.receiveBaseForm.setVal('linkman', name);
                  }
                }
                if (identification) {
                  msg += `身份证号码为：${identification}，`;
                  this.$refs.baseForm.setVal('identification', identification);
                }
                msg += '将覆盖掉您填写的（识别出来为空的不覆盖）！';
                if (name || identification) {
                  this.$alert(msg, '温馨提示', {
                    confirmButtonText: '我知道了',
                  });
                }
              }
            },
          },
          {
            label: '身份证国徽面',
            value: 'idenPictureBack',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            attr: {
              limit: 1,
            },
            default: [],
          },
          {
            label: '身份证/驾驶证号',
            value: 'identification',
            type: 'input',
          },
          {
            value: 'driverCard',
            allCustom: true,
          },
          {
            label: '驾驶证正本',
            value: 'adriverLicenseOriginal',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            attr: {
              limit: 1,
            },
            default: [],
            onChange: async (arr) => {
              if (arr && arr[0] && arr[0].url) {
                const loading = this.$loading({
                  background: 'rgba(0, 0, 0, 0.7)',
                });
                const drivingLicenseInfo = await getDrivingLicense({ url: getBigImg(arr[0].url) });
                loading.close();
                let msg = '您上传的驾驶证照片，系统识别出';
                const drivingLicense = drivingLicenseInfo.drivingLicense;
                const vehicleType = drivingLicenseInfo.vehicleType;
                const effectiveDate = drivingLicenseInfo.effectiveDate;
                const expiryDate = drivingLicenseInfo.expiryDate;
                if (drivingLicense) {
                  msg += `驾驶证号为：${drivingLicense}，`;
                  this.$refs.baseForm.setVal('adriverLicenseSn', drivingLicense);
                }
                if (vehicleType) {
                  msg += `准驾车型为：${vehicleType}，`;
                  this.$refs.baseForm.setVal('vehicleType', vehicleType);
                }
                if (effectiveDate) {
                  msg += `驾驶证有效期为：${effectiveDate} - ${expiryDate}，`;
                  this.$refs.baseForm.setVal('driverLicenseTime', [effectiveDate, expiryDate]);
                }
                msg += '将覆盖掉您填写的（识别出来为空的不覆盖）！';
                if (drivingLicense || vehicleType || effectiveDate) {
                  this.$alert(msg, '温馨提示', {
                    confirmButtonText: '我知道了',
                  });
                }
              }
            },
          },
          {
            label: '驾驶证副本',
            value: 'adriverLicenseDuplicate',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            attr: {
              limit: 1,
            },
            default: [],
          },
          {
            label: '驾驶证号',
            value: 'adriverLicenseSn',
            type: 'input',
            hide: true,
          },
          {
            label: '准驾车型',
            value: 'vehicleType',
            type: 'select',
          },
          {
            label: '证件有效期',
            value: 'driverLicenseTime',
            type: 'date',
            // slot:true,
            attr: {
              type: 'daterange',
            },
            endPlaceholder: '长期',
            pickerOptions: {
              shortcuts: [{
                text: '6年',
                onClick (picker) {
                  let end = new Date();
                  const start = new Date();
                  if (picker.minDate) {
                    end = new Date(picker.minDate.getFullYear() + 6, picker.minDate.getMonth(), picker.minDate.getDate());
                  } else {
                    end.setFullYear(start.getFullYear() + 10);
                  }
                  picker.$emit('pick', [picker.minDate ? new Date(picker.minDate) : new Date(start), end]);
                },
              },
              {
                text: '10年',
                onClick (picker) {
                  let end = new Date();
                  const start = new Date();
                  if (picker.minDate) {
                    end = new Date(picker.minDate.getFullYear() + 10, picker.minDate.getMonth(), picker.minDate.getDate());
                  } else {
                    end.setFullYear(start.getFullYear() + 10);
                  }
                  picker.$emit('pick', [picker.minDate ? new Date(picker.minDate) : new Date(start), end]);
                },
              },
              {
                text: '长期',
                onClick (picker) {
                  picker.$emit('pick', [picker.minDate ? new Date(picker.minDate) : new Date(), '长期']);
                },

              }],
            },
          },
          {
            value: 'workCard',
            allCustom: true,
          },
          {
            label: '从业资格证',
            value: 'qcCerti',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            attr: {
              limit: 1,
            },
            default: [],
          },
          {
            label: '从业证类型',
            value: 'qcCertiType',
            type: 'select',
          },
          {
            label: '证件有效期',
            value: 'qcCertiTime',
            type: 'date',
            attr: {
              type: 'daterange',
            },
          },
          {
            value: 'otherCard',
            allCustom: true,
          },
          {
            label: '安全责任协议',
            value: 'safetyAgreement',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            attr: {
              limit: 1,
            },
            default: [],
          },
          {
            label: '司机合同',
            value: 'driverContract',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            attr: {
              limit: 1,
            },
            default: [],
          },
        ],
        rules: {
          // identification: [ // 身份证号
          //   { required: true, message: '请输入身份证号', trigger: 'blur' },
          // ],
          // idenPictureFront: [ // 身份证头像面
          //   { required: true, message: '请上传身份证头像面', trigger: 'blur' },
          // ],
          // idenPictureBack: [ // 身份证国徽面
          //   { required: true, message: '请上传身份证国徽面', trigger: 'blur' },
          // ],
          // adriverLicenseSn: [ // 驾驶证号
          //   { required: true, message: '请输入驾驶证号', trigger: 'blur' },
          // ],
          // vehicleType: [ // 准驾车型
          //   { required: true, message: '请选择准驾车型', trigger: 'blur' },
          // ],
          // driverLicenseTime: [ // 证件有效期
          //   { required: true, message: '请选择证件有效期', trigger: 'blur' },
          // ],
          // adriverLicenseOriginal: [ // 驾驶证正本
          //   { required: true, message: '请上传驾驶证正本', trigger: 'blur' },
          // ],
          // adriverLicenseDuplicate: [ // 驾驶证副本
          //   { required: true, message: '请上传驾驶证副本', trigger: 'blur' },
          // ],
        },
      },
    };
  },
};
</script>

<style scoped lang="scss">
.titleLine {
  background-color: #f3f3f3;
  height: 40px;
  line-height: 40px;
  padding-left: 40px;
  padding-right: 40px;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
}
</style>
